/** @module app.test.pages */

import { autoinject, observable } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { EnvironmentService } from 'app/shared/services/environment-service';
import { DateTimeValue } from 'app/shared/lib/date-time';

interface ITimeZone {
    display: string,
    name: string,
    std: {
        abbr: string,
        offset: string
    },
    dst?: {
        abbr: string,
        offset: string
    },
    city: string
}

interface IFormat {
    display: string;
    format: string;
}

interface IDateTime {
    name?: string,
    value: string
}

@autoinject
export class DateTestsPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////

    protected timeZones: ITimeZone[] = [
        { display: 'Eastern Time', name: 'America/New_York', std: { abbr: 'EST', offset: 'UTC-05:00' }, dst: { abbr: 'EDT', offset: 'UTC-04:00' }, city: 'New York, NY, USA' },
        { display: 'Central Time', name: 'America/Chicago', std: { abbr: 'CST', offset: 'UTC-06:00' }, dst: { abbr: 'CDT', offset: 'UTC-05:00' }, city: 'Chicago, IL, USA' },
        { display: 'Mountain Time', name: 'America/Denver', std: { abbr: 'MST', offset: 'UTC-07:00' }, dst: { abbr: 'MDT', offset: 'UTC-06:00' }, city: 'Denver, CO, USA' },
        { display: 'Pacific Time', name: 'America/Los_Angeles', std: { abbr: 'PST', offset: 'UTC-08:00' }, dst: { abbr: 'PDT', offset: 'UTC-07:00' }, city: 'Los Angeles, CA, USA' }
    ];

    protected dateTimeFormats: IFormat[] = [
        { display: 'Default', format: 'default' },
        { display: 'Long', format: 'long' },
        { display: 'Date', format: 'date' },
        { display: 'Date: Long', format: 'dateLong' },
        { display: 'Time', format: 'time' },
        { display: 'Time: Short', format: 'timeShort' }
    ];

    protected dateTimes: IDateTime[] = [];

    @observable
    protected timeZone: ITimeZone | null = null;

    @observable
    protected dateTimeFormat: IFormat = this.dateTimeFormats[0];

    ////****************** Element References ***************************************////



    ////****************** Lifecycle events (in order of execution) *****************////

    constructor(...rest: any[]) {
        super(...rest);
    }

    protected async activate(params: any): Promise<void> {

        const now = new DateTimeValue(this.env.now());

        this.dateTimes.push(
            { value: now.toString(), name: 'Now' },
            { value: "2019-01-01T07:00:00.000Z", name: "New Year's Day" },
            { value: "2019-01-21T07:00:00.000Z", name: "MLK, Jr. Day" },
            { value: "2019-02-18T07:00:00.000Z", name: "Presidents This" },
            { value: "2019-05-27T06:00:00.000Z", name: "Memorial Day" },
            { value: "2019-07-04T06:00:00.000Z", name: "Independence Day" },
            { value: "2019-09-02T06:00:00.000Z", name: "Labor Day" },
            { value: "2019-10-14T06:00:00.000Z", name: "Columbus Day" },
            { value: "2019-11-11T07:00:00.000Z", name: "Veterans Day" },
            { value: "2019-11-28T07:00:00.000Z", name: "Thanksgiving Day" },
            { value: "2019-12-25T07:00:00.000Z", name: "Christmas Day" },
        );

        // for(let day = 10; day < 1000; day += 10) {
        //     this.dateTimes.push(
        //         { value: now.add(day, 'days').toString() }
        //     );
        // }

    }

    //protected created(owningView: View, myView: View): void { }
    //protected bind(bindingContext: Object, overrideContext: Object): void { }
    //protected attached(): void { }
    //protected deactivate(): void { }
    //protected detached(): void { }
    //protected unbind(): void { }



    ////****************** Events ***************************************************////

    protected selectTimeZone(timeZone: ITimeZone): void {
        this.timeZone = timeZone;

        this.env.displayTimeZone = timeZone.name;
    }

    protected selectDateTimeFormat(format: IFormat): void {
        this.dateTimeFormat = format;
    }

    ////****************** Functions ************************************************////



    ////****************** Service Calls ********************************************////

}
